import React, { Component } from 'react'
export class HoverMenu extends Component {
  constructor(props) {
    super(props)

    this.state = { dropdownOpen: false }
    this.handleMouseEnter = this.handleMouse.bind(this)
    this.handleMouseLeave = this.handleMouse.bind(this)
  }

  handleMouse = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }))
  }

  render() {
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <a tabindex="1" href={this.props.url}>
          {this.props.text}
        </a>
        <ul
          className="left"
          style={
            !this.state.dropdownOpen
              ? { display: 'none' }
              : { display: 'block' }
          }
        >
          {this.props.children}
        </ul>
      </div>
    )
  }
}

export const AdminMenu = () => [
  <li key="divider" className="divider" />,
  <li key="myAccountNav" id="myAccountNav">
    <a
      tabindex="1"
      href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Admin/EditAccount`}
    >
      My Admin Account
    </a>
  </li>,
  <li key="supportNav" id="supportNav">
    <HoverMenu
      text="Success"
      url={`${
        process.env.REACT_APP_FOODSBY_BASE_URL
      }/support/app#/Dashboard/Old`}
    >
      <li id="dashboard2Nav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/support/app#/Dashboard/Main`}
        >
          Dashboard
        </a>
      </li>
      <li id="dashboardLateNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/support/app#/Dashboard/Late`}
        >
          Dashboard Late
        </a>
      </li>
      <li id="orderRefundManagementNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/support/app#/Orders/Find`}
        >
          Order/Refund Management
        </a>
      </li>
      <li id="findOrderDetailsNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Admin/FindOrder`}
        >
          Find Order Details
        </a>
      </li>
      <li id="driversNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Driver`}
        >
          Drivers
        </a>
      </li>
      <li id="messagesNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Inbox/Index`}
        >
          Messages
        </a>
      </li>
      <li id="supportStoresMenusNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Store`}
        >
          Stores/Menus
        </a>
      </li>
      <li id="marketsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/FoodsbyMarket/list`}
        >
          Markets
        </a>
      </li>
      <li id="couponsNav">
        <a
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Navigation/Coupons`}
        >
          Coupons
        </a>
      </li>
    </HoverMenu>
  </li>,
  <li key="schedulingNav" id="schedulingNav">
    <HoverMenu
      url={`${
        process.env.REACT_APP_FOODSBY_BASE_URL
      }/Sales/App#/Schedule/Calendar`}
      text="Scheduling"
    >
      <li id="scheduleNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/Schedule/Calendar`}
        >
          Schedule
        </a>
      </li>
      <li id="zoningNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/Schedule/Zones`}
        >
          Zoning
        </a>
      </li>
      <li id="scheduleMapsNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Map/Index`}
        >
          Maps
        </a>
      </li>
      <li id="groupsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/Schedule/Groups`}
        >
          Groups
        </a>
      </li>
    </HoverMenu>
  </li>,
  <li key="salesMarketingNav" id="salesMarketingNav">
    <HoverMenu
      text="Sales/Marketing"
      url={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Sales/App`}
    >
      <li id="mapsNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Map/Index`}
        >
          Maps
        </a>
      </li>
      <li id="locationsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/Location/List`}
        >
          Locations
        </a>
      </li>
      <li id="storesMenusAgainNav">
        <a
          tabindex="1"
          href={`${process.env.REACT_APP_FOODSBY_BASE_URL}/Store`}
        >
          Stores/Menus
        </a>
      </li>
      <li id="marketsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/FoodsbyMarket/list`}
        >
          Markets
        </a>
      </li>
      <li id="marketsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/market/list`}
        >
          States
        </a>
      </li>
      <li id="notificationsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Sales/App#/Campaign/dailyEmails`}
        >
          Notifications
        </a>
      </li>
    </HoverMenu>
  </li>,
  <li key="usersNav" id="usersNav">
    <HoverMenu
      text="Users"
      url={`${
        process.env.REACT_APP_FOODSBY_BASE_URL
      }/Support/App#/UserManagement/List`}
    >
      <li id="listNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Support/App#/UserManagement/List`}
        >
          List
        </a>
      </li>
      <li id="makeAdminNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Support/App#/UserManagement/Roles`}
        >
          Make Admin
        </a>
      </li>
    </HoverMenu>
  </li>,
  <li key="reportsDashNav" id="reportsDashNav">
    <HoverMenu text="Reports/Dashboards" url={process.env.REACT_APP_STATS_URL}>
      <li id="statsNav">
        <a href={process.env.REACT_APP_STATS_URL}>Stats</a>
      </li>
      <li id="reportsNav">
        <a
          href={`${
            process.env.REACT_APP_FOODSBY_BASE_URL
          }/Navigation/Reporting`}
        >
          Reports
        </a>
      </li>
    </HoverMenu>
  </li>
]
